import { Outlet } from "react-router-dom";
import adminRouteMap from "routeControl/adminRouteMap";
import { CmsPages } from "pages";

/**
 * Generates an array of route objects for managing CMS in the admin section.
 * @returns {Array} An array containing the route object for managing CMS.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.MANAGE_CMS.path,  // URL path for managing CMS
      private: true,  // Requires authentication to access
      name: "Manage CMS",  // Display name for the route
      key: adminRouteMap.MANAGE_CMS.path,  // Unique key for the route
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.MANAGE_CMS.icon,  // Icon associated with managing CMS
      element: <Outlet />,  // Acts as a placeholder for child routes
      children: [
        {
          path: adminRouteMap.ABOUT_US.path,
          private: true,
          name: "About Us",
          key: adminRouteMap.ABOUT_US.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
        {
          path: adminRouteMap.PRIVACY_POLICY.path,
          private: true,
          name: "Privacy Policy",
          key: adminRouteMap.PRIVACY_POLICY.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
        {
          path: adminRouteMap.TERMS_AND_CONDITION.path,
          private: true,
          name: "Terms and Conditions",
          key: adminRouteMap.TERMS_AND_CONDITION.path,
          belongsToSidebar: true,
          element: <CmsPages />,
        },
        // {
        //   path: adminRouteMap.FAQS.path,  // URL path for FAQs under Manage CMS
        //   private: true,  // Requires authentication to access
        //   name: "Faqs",  // Display name for the FAQs route
        //   key: adminRouteMap.FAQS.path,  // Unique key for the FAQs route
        //   belongsToSidebar: true,  // Appears in the admin sidebar
        //   element: <FAQS />,  // Component to render for FAQs route
        // },
      ],
    },
  ];
}
